/**
 * 正式运行时以已保存的产物格式为准，避免项目切换编辑模式但尚未重新保存时，
 * 用 remote runtime 加载旧的 CJS 产物。
 */
export function shouldUseRemoteRuntime(aiConfig, aiProjectInfo, { isPreview = false, isLiveDebug = false } = {}) {
    if (isLiveDebug)
        return true;
    if (isPreview) {
        return aiConfig?.useRemoteEditor === true;
    }
    const artifactModule = aiProjectInfo?.artifact?.meta?.module
        || aiProjectInfo?.artifactCos?.meta?.module;
    return artifactModule === 'esm';
}
